var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrosives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#ff462e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "corrosives",
    transform: "translate(.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffce6e",
    transform: "translate(-.411)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "GHS-pictogram-acid",
    transform: "translate(14.347 14.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    d: "M493.29 305.727c-.321 1.655-1.01 3.242-1.01 3.678 0 .567.169 1.983 1.239 1.983s1.41-1.259 1.41-2.169c0-.722-.632-1.89-.9-3.579a1.311 1.311 0 0 1-.534.108 1.077 1.077 0 0 1-.2-.02",
    className: "cls-2",
    transform: "translate(-473.173 -292.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    d: "M371.848 229.645c1.859.3 14.887 2.468 15.832 2.618.538.085.978.44.978.587a3.5 3.5 0 0 0-.575 1.662c0 .737.115 1.9.97 2.059a1.064 1.064 0 0 0 .2.02 1.285 1.285 0 0 0 .534-.108 1.9 1.9 0 0 0 .9-1.811c0-1.7-.883-1.365-.671-2.974.059-.446.917-6.28.917-6.28-.694.322-.878 1.521-2.4 1.23-1.033-.2-12.982-2.4-15.321-2.775s-3.929.846-4.229 2.407 1 3.066 2.863 3.363m1.394-4.609c1.613.265 16.127 2.8 16.127 2.8l-.3 1.958s-15.011-1.314-16.592-1.413-2.305-.644-2.305-1.661 1.264-1.983 3.074-1.686",
    className: "cls-2",
    transform: "translate(-368.942 -223.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    d: "M527.2 285.622a.823.823 0 0 1-.079.465 1.606 1.606 0 0 1-.93.971l.271 1.159a2.611 2.611 0 0 0 1.751-1.642 1.97 1.97 0 0 0 .183-1.013.671.671 0 0 1 .144-.513c.113-.177.144-.184.279-.22a1.373 1.373 0 0 0 .957-.775 2.106 2.106 0 0 0 .152-1.565 1.55 1.55 0 0 1-.051-.556c.042-.266.229-.471.587-.838a8.87 8.87 0 0 0 .637-.71l-.93-.736a7.327 7.327 0 0 1-.555.615 2.735 2.735 0 0 0-.909 1.481 2.586 2.586 0 0 0 .062.984.954.954 0 0 1-.036.759c-.081.152-.084.152-.211.186a1.5 1.5 0 0 0-.982.734 1.823 1.823 0 0 0-.328 1.21",
    className: "cls-2",
    transform: "translate(-501.83 -270.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    d: "M513.786 292.546a2.578 2.578 0 0 0 1.007-1.52 2.634 2.634 0 0 0 .1-1.191 1.626 1.626 0 0 1 .036-.691c.04-.152.054-.158.22-.248a1.55 1.55 0 0 0 .866-1.1 1.919 1.919 0 0 0-.166-1.414.979.979 0 0 1-.119-.706l-1.171-.214a2.142 2.142 0 0 0 .209 1.414.758.758 0 0 1 .094.62.4.4 0 0 1-.276.347 1.447 1.447 0 0 0-.809.99 2.759 2.759 0 0 0-.07 1.125 1.452 1.452 0 0 1-.053.71 1.487 1.487 0 0 1-.657.979l-.277.246.8.885.267-.237",
    className: "cls-2",
    transform: "translate(-490.446 -275.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    d: "M462.449 293.27a1.634 1.634 0 0 0 .869 1.05c.282.175.378.246.417.434a.754.754 0 0 1-.008.5 1.43 1.43 0 0 0-.02.957 3.563 3.563 0 0 0 1.255 1.839l.841-.841c-.751-.751-.813-.838-.953-1.325a.3.3 0 0 1 0-.253 1.911 1.911 0 0 0 .043-1.125 1.8 1.8 0 0 0-.956-1.2c-.243-.15-.31-.2-.333-.3a1.048 1.048 0 0 1 .1-.617 2.847 2.847 0 0 0 .2-1.383l-1.182.139a1.7 1.7 0 0 1-.141.847 2.167 2.167 0 0 0-.142 1.275",
    className: "cls-2",
    transform: "translate(-447.924 -280.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    d: "M445.094 289.335a2.326 2.326 0 0 0-.132-.753 3.549 3.549 0 0 0-.894-1.484l-.333-.378-.916.759.373.423a2.39 2.39 0 0 1 .644 1.063 1.147 1.147 0 0 1 .026.7 1.985 1.985 0 0 0 .122 1.32 1.572 1.572 0 0 0 1.016.922c.192.071.226.084.294.228a.559.559 0 0 1 .073.448 1.244 1.244 0 0 0 .07.829c.212.483.812 1.624 1.783 1.766l.18-1.178c-.239-.036-.62-.5-.868-1.067l-.009-.028.016-.079a1.827 1.827 0 0 0 .046-.386 1.9 1.9 0 0 0-.2-.807 1.5 1.5 0 0 0-.962-.844c-.2-.076-.253-.093-.339-.288a.769.769 0 0 1-.081-.324 1.6 1.6 0 0 1 .039-.287 2.8 2.8 0 0 0 .065-.555",
    className: "cls-2",
    transform: "translate(-431.375 -276.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    d: "M456.7 345.637a4.465 4.465 0 0 1-5.159-.242l-.291-.265-.358.166a4.817 4.817 0 0 1-1.808.282c-.723.02-1.3.037-1.588.494a1.2 1.2 0 0 0 .057 1.238 2.209 2.209 0 0 0 .141.223h2.595a1.905 1.905 0 0 1-1.659-.744c.152-.011.333-.019.488-.022a6.736 6.736 0 0 0 1.907-.262 5.177 5.177 0 0 0 2.459.968 3.3 3.3 0 0 1 2.352-1.029v.891a4.562 4.562 0 0 0 1.326-.565 20.8 20.8 0 0 1 2.135 1.184 7.889 7.889 0 0 0 .978.552 20.135 20.135 0 0 0 4.181.392v-1.19a20.9 20.9 0 0 1-3.749-.313c-.095-.039-.479-.271-.785-.459a16.767 16.767 0 0 0-2.649-1.41l-.308-.1-.253.2",
    className: "cls-2",
    transform: "translate(-435.203 -326.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    d: "M430.021 360.6h-4.438c-2 0-2.212 1.224-2.212 1.653a1.767 1.767 0 0 0 .056.434h1.8c-.53 0-.7-.208-.7-.429s.2-.465 1.052-.465h7.125a2.157 2.157 0 0 1 .459-1.19h-3.145",
    className: "cls-2",
    transform: "translate(-414.938 -339.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    d: "M491.392 361.81h.17l3.557-.83-2.029-.359h-.037v.1c-.016 0-1.489.067-1.662 1.084",
    className: "cls-2",
    transform: "translate(-472.421 -339.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    d: "M408.838 374.1a1.859 1.859 0 0 0-1.918 1.741 1.884 1.884 0 0 0 1.977 1.771h.37c.085-.457.449-1.108 1.8-1.182v-.008H408.9a.893.893 0 0 1-.787-.582.691.691 0 0 1 .728-.55h7.729v-1.19h-7.729",
    className: "cls-2",
    transform: "translate(-401.036 -350.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    d: "M421.873 390.2a1.358 1.358 0 0 0-.023.257c0 .976.86 1.771 2.324 1.771h.028a2.222 2.222 0 0 1 2.118-1.184v-.008h-2.146c-.737 0-1.14-.384-1.14-.581 0-.169.455-.257.9-.257h5.232v-1.19h-5.232c-.093 0-.18 0-.265.008-1.356.074-1.72.725-1.8 1.182",
    className: "cls-2",
    transform: "translate(-413.654 -363.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    d: "M436.754 403.31a1.168 1.168 0 0 0-.064.375c0 .747.669 1.549 2.163 1.681 1.081.09 5.747.237 6.6.237a24.664 24.664 0 0 0 5.193-.553 8.6 8.6 0 0 0 1.239-.5 7.091 7.091 0 0 1 3.5-.775v-1.19a8.214 8.214 0 0 0-4 .885 7.579 7.579 0 0 1-1.07.432 23.777 23.777 0 0 1-4.86.505c-.79 0-5.453-.146-6.5-.232-.756-.063-1.07-.353-1.07-.494.026-.073.39-.375 1.227-.375h4.79l-1.146-1.19h-3.644c-.079 0-.158 0-.235.008a2.219 2.219 0 0 0-2.118 1.182",
    className: "cls-2",
    transform: "translate(-426.195 -374.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    d: "M484.078 354.606l-.05.059a2.157 2.157 0 0 0-.459 1.19c0 .067-.009.133-.009.2 0 1.106.582 3.036 4.486 3.531l.149-1.18c-1.287-.163-3.439-.685-3.439-2.35a1.209 1.209 0 0 1 .017-.2c.175-1.021 1.647-1.084 1.662-1.084v-1.19a3.3 3.3 0 0 0-2.352 1.027",
    className: "cls-2",
    transform: "translate(-465.804 -333.476)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrosives);
export default __webpack_public_path__ + "static/media/corrosives.c6eb0a3f57ea744e4fb67b0b061a0d0f.svg";
export { ForwardRef as ReactComponent };